<template>
  <div class="noRight" v-if="ts">
    <span>{{ ts }}</span>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      username: "",
      password: "",
      user: "",
      isForm: false,
      ip: "",
      ts: "",
    };
  },
  mounted() {
    this.$ajax.get("/configure/configure.json").then((res) => {
      this.$store.commit("saveconfigure", res);
      if (res.iswhiteList) {
        this.$ajax.post(`/common/check/ip`, {}).then((res) => {
          if (res.result) {
            this.loginDockkey();
          } else {
            this.ts = "ip：" + res.ip;
          }
        });
      } else {
        this.loginDockkey();
      }
    });
  },
  methods: {
    loginDockkey() {
      if (this.$route.query.dockkey) {
        this.$ajax
          .post(`/login/callback/frontend`, {
            dockKey: this.$route.query.dockkey,
          })
          .then((res) => {
            this.init_table();
          });
      } else if (this.$route.query.code) {
        this.$ajax
          .post(`/login/callback/frontend`, { code: this.$route.query.code })
          .then((res) => {
            this.init_table();
          });
      } else {
        this.$ajax.post(`/login/callback/frontend`, { dockKey: "" }).then((res) => {
          window.location.replace(res.data.redirectUrl);
        });
      }
    },
    init_table: function () {
      this.$router.push({ name: "IndexPage" });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/login.vue